import Actor from "../../actors/Actor";

export default class Mixture extends Actor {
    constructor(texture, position) {
        super(P3.assets.texture(texture));
        this.x = position.x;
        this.y = position.y;
        this.view.scale.set(1);
        this._targetPos = this.y - 20;
        this._animatingMixture = false;
        this.createAnimations();
        this.nextColour = "0xFFFFFF";
    }

    destroy() {
        super.destroy();
    }

    update() {
        this.view.tint = this.lerpColor(this.view.tint, this.nextColour, 0.1);
    }

    createAnimations(){
        this._moveUpTween = new P3.utils.TWEEN.Tween(this)
            .to({
                y: this._targetPos
            }, 1000)
            .onStart(()=>{
                this._animatingMixture = true;
            })
            .onComplete(()=>{
                this._animatingMixture = false;
            })
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut);
    }

    changeColour(colour){
        this.nextColour = colour
    }

    animateMixtureRise(){
        this.createAnimations();
        this._moveUpTween.start();
        this._targetPos -= 15;
    }

    animateUp(){
        return new P3.utils.TWEEN.Tween(this)
            .to({
                y: this.y - 100
            }, 2000)
            .easing(P3.utils.Easing.Back2.Out)
            .onStart(()=> {
                this._animating = true;
            });
    }

    animateDown(){
        this._floatTween.stop();
        return new P3.utils.TWEEN.Tween(this)
            .to({
                y: this.y + 100
            }, 2000)
            .easing(P3.utils.Easing.Back2.In)
            .onStart(()=> {
                this._animating = true;
            })
            .onComplete(()=>{
                this._animating = false;
            })
            .start();

    }

    animateFloat(){
        this._floatTween = new P3.utils.TWEEN.Tween(this)
            .to({
                y: this.y + 10
            }, 2000)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .repeat(Infinity)
            .yoyo(true)
            .start();
    }

    lerpColor(a, b, amount) {
        let ah = parseInt(a, 16),
            ar = ah >> 16, ag = ah >> 8 & 0xff, ab = ah & 0xff,
            bh = parseInt(b, 16),
            br = bh >> 16, bg = bh >> 8 & 0xff, bb = bh & 0xff,
            rr = ar + amount * (br - ar),
            rg = ag + amount * (bg - ag),
            rb = ab + amount * (bb - ab);

        return '0x' + ((1 << 24) + (rr << 16) + (rg << 8) + rb | 0).toString(16).slice(1);
    }

    convertHex(hex){
        hex = hex.replace('0x','');
        let r = parseInt(hex.substring(0,2), 16);
        let g = parseInt(hex.substring(2,4), 16);
        let b = parseInt(hex.substring(4,6), 16);
        return {r: r, b: b, g: g};
    }
}